/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Company_User_Validation_FailedInputs */

const en_admin_create_company_user_validation_failed = /** @type {(inputs: Admin_Create_Company_User_Validation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please check your inputs.`)
};

const de_admin_create_company_user_validation_failed = /** @type {(inputs: Admin_Create_Company_User_Validation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte überprüfen Sie Ihre Eingaben.`)
};

/**
* | output |
* | --- |
* | "Please check your inputs." |
*
* @param {Admin_Create_Company_User_Validation_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_company_user_validation_failed = /** @type {((inputs?: Admin_Create_Company_User_Validation_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Company_User_Validation_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_company_user_validation_failed(inputs)
	return en_admin_create_company_user_validation_failed(inputs)
});